import { ICellRendererParams } from "ag-grid-enterprise";
import { DeltaIndicator } from "../../components/DeltaIndicator";

export function DeltaCellRenderer(params: ICellRendererParams) {
    const delta = params.value as number | null;
    return <DeltaIndicator delta={delta} />;
}
